import { useTranslation } from 'react-i18next';
import usePageMeta from '@/hooks/usePageMeta';
import PageHero from '@/components/feature/PageHero';
import ProcessingIntroSection from '@/pages/processing/components/ProcessingIntroSection';
import CapabilitiesSection from '@/pages/processing/components/CapabilitiesSection';
import MaterialsSection from '@/pages/processing/components/MaterialsSection';
import GallerySection from '@/pages/processing/components/GallerySection';
import CtaSection from '@/pages/home/components/CtaSection';

export default function Processing() {
  const { t } = useTranslation();

  usePageMeta({
    title: 'Blechbearbeitung | Zuschnitt & Stanzen | S+N Metall',
    description:
      'Blechbearbeitung bei S+N Metall in Lauter-Bernsbach: Zuschnitt, Stanzen, Kanten und Montagearbeiten für alle gängigen Blecharten wie Edelstahl, Stahl und Aluminium.',
    keywords: 'Blechbearbeitung, Zuschnitt, Stanzen, Kanten, Montagearbeiten, Edelstahl',
  });

  return (
    <>
      <PageHero
        eyebrow={t('processing.hero.eyebrow')}
        title={t('processing.hero.title')}
        subtitle={t('processing.hero.subtitle')}
      />
      <ProcessingIntroSection />
      <CapabilitiesSection />
      <MaterialsSection />
      <GallerySection />
      <CtaSection />
    </>
  );
}